export default "__VITE_PUBLIC_ASSET__90bc44ab__"